<script setup lang="ts">
const { product } = useProduct();
const { t } = useI18n();

const showCalculator = ref<boolean>(false);
const calculator = ref(null);

const quantityComparison = computed(
  () =>
    product.value?.translated?.customFields?.customfields_quantity_comparison
);

const height = ref(null);
const width = ref(null);
const coveragePerLiter = 13;

const totalArea = computed(() => {
  if (!height.value || !width.value) return null;
  return height.value * width.value;
});

const requiredLiters = computed(() => {
  if (!totalArea.value) return null;
  const liter = Math.ceil(totalArea.value / coveragePerLiter);
  return t("product.quantityCalculator.liter", { liter });
});

const priceCalculatorCategories = [
  "0190a6f885ae79bbb984eb358cacec65",
  "0190a6f89a1a7a75b58e749f40381d4f",
  "01928bc17c9d7f05855a81c7a999371d",
];

const isPriceCalculatorEnabled = computed(
  () =>
    product.value?.categoryIds?.[0] &&
    priceCalculatorCategories.includes(product.value.categoryIds[0])
);
</script>
<template>
  <div v-if="isPriceCalculatorEnabled">
    <div>
      <p class="text-sm md:text-lg">
        {{ quantityComparison }}
        <span class="text-cust_green inline-block mx-1">
          <i class="fa-solid fa-arrow-right"></i>
        </span>
        <button @click="showCalculator = true" class="loadQty underline">
          {{ $t("product.quantityCalculator.label") }}
        </button>
        <span class="text-cust_green inline-block mx-1">
          <i class="fa-regular fa-copy"></i>
        </span>
      </p>
    </div>

    <div
      ref="calculator"
      class="popup-wrapper popup02 w-screen h-screen bg-[rgba(126,160,129,0.4)] fixed top-0 start-0 z-[51] flex items-center justify-center"
      :class="{ show: showCalculator }"
    >
      <div
        class="py-7 md:py-12 px-4 md:px-8 rounded-2xl md:rounded-3xl bg-white md:max-w-[480px] max-w-[94%] flex flex-col gap-4 md:gap-6"
      >
        <div class="flex gap-5 items-center justify-between">
          <h4 class="mb-0">
            {{ $t("product.quantityCalculator.title") }}
          </h4>
          <button
            @click="showCalculator = false"
            class="closePop text-2xl md:text-3xl text-cust_gray cursor-pointer"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <p>
          {{ $t("product.quantityCalculator.description") }}
        </p>
        <div class="flex justify-between items-center">
          <div>
            <input
              type="number"
              class="inputField"
              min="1"
              v-model.number="height"
              :placeholder="$t('product.quantityCalculator.height')"
            />
          </div>
          <div class="text-cust_gray text-lg md:text-2xl">
            <i class="fa-solid fa-xmark"></i>
          </div>
          <div>
            <input
              type="number"
              class="inputField"
              min="1"
              v-model.number="width"
              :placeholder="$t('product.quantityCalculator.width')"
            />
          </div>
          <div class="text-cust_gray text-lg md:text-2xl">
            <i class="fa-solid fa-arrow-right"></i>
          </div>
          <div>
            <input
              type="number"
              class="inputField w-[113px] md:w-[145px]"
              readonly
              :value="totalArea?.toFixed(2)"
              :placeholder="$t('product.quantityCalculator.totalArea')"
            />
          </div>
        </div>
        <div class="flex items-center justify-between text-sm md:text-lg">
          <p>
            {{ $t("product.quantityCalculator.projectRequirementLabel") }}
          </p>
          <div>
            <input
              type="text"
              class="inputField w-[113px] md:w-[145px]"
              :value="requiredLiters"
              readonly
              :placeholder="
                $t('product.quantityCalculator.totalRequiredPlaceholder')
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
